export default {
  path: 'stops',
  name: 'stops',
  redirect: { name: 'stops.listing' },
  component: () => import(/* webpackChunkName: "stops" */ '@/views/Home/Stops'),
  children: [
    {
      path: '/',
      name: 'stops.listing',
      component: () =>
        import(/* webpackChunkName: "stops" */ '@/views/Home/Stops/StopList')
    },
    {
      path: 'create',
      name: 'stops.create',
      component: () =>
        import(/* webpackChunkName: "stops" */ '@/views/Home/Stops/CreateStop')
    },
    {
      path: 'update/:id',
      name: 'stops.update',
      component: () =>
        import(/* webpackChunkName: "stops" */ '@/views/Home/Stops/UpdateStop')
    }
  ]
}
